import Swal from "sweetalert2";
/**
 * HandleDownload
 * ----------------
 * Función utilitaria encargada de descargar el checklist de cámaras
 * en formato CSV a partir de un rango de fechas y un cliente.
 *
 * Flujo general:
 * 1. Consulta la información al backend
 * 2. Valida la respuesta y la existencia de datos
 * 3. Genera el contenido CSV
 * 4. Crea y dispara la descarga del archivo
 * 5. Maneja errores y notificaciones al usuario
 *
 * @param {string} fechaInicio - Fecha inicial del rango de consulta (YYYY-MM-DD)
 * @param {string} fechaFin - Fecha final del rango de consulta (YYYY-MM-DD)
 * @param {string} cliente - Cliente seleccionado para el filtro
 * @param {Function} getCheckListDevice - Servicio que obtiene el checklist desde el backend
 */
export const HandleDownload = async (
    fechaInicio,
    fechaFin,
    cliente,
    getCheckListDevice
) => {
    try {
        // Consulta al backend para obtener el checklist según filtros
        const resp = await getCheckListDevice(fechaInicio, fechaFin, cliente);

        // Validación de respuesta del servicio
        if (!resp.ok) {
            Swal.fire({
                title: "Lo siento!",
                text: resp.msg,
                icon: "info",
            });
            return;
        }

        // Se obtienen los registros del checklist
        const rows = resp.resultado || [];

        // Validación cuando no existen datos en el rango seleccionado
        if (rows.length === 0) {
            Swal.fire("Sin datos", "No hay información en el rango seleccionado", "info");
            return;
        }

        // Encabezados del archivo CSV
        const headers = [
            "Cliente",
            "MDVR",
            "Fecha",
            "Cam 1",
            "Cam 2",
            "Cam 3",
            "Cam 4",
            "Estatus General",
            "GPS",
            "Grabación",
            "Responsable"
        ];

        /**
         * Construcción del contenido CSV
         * - Se agrega BOM (\uFEFF) para compatibilidad con Excel
         * - Se escapan valores nulos
         * - Se convierten valores booleanos a SI / NO
         */
        const csvContent = "\uFEFF" + [
            headers.join(","),
            ...rows.map(r => [
                r.cliente,
                r.mdvr,
                r.fecha,
                r.cam1,
                r.cam2,
                r.cam3,
                r.cam4,
                r.estatus_general,
                r.gps ? "SI" : "NO",
                r.grabacion ? "SI" : "NO",
                r.responsable
            ].map(v => `"${v ?? ""}"`).join(","))
        ].join("\n");

        // Se crea el archivo CSV como Blob
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        // Se genera la URL temporal para la descarga
        const url = URL.createObjectURL(blob);

        // Creación dinámica del enlace para disparar la descarga
        const link = document.createElement("a");
        link.href = url;
        link.download = `checklist_camaras_${fechaInicio}_al_${fechaFin}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

    } catch (error) {
        // Manejo de errores inesperados
        console.error(error);
        Swal.fire("Error", "No se pudo descargar el reporte", "error");
    }
};
